<div class="d-flex flex-wrap align-items-center gap-4">

  <!-- Dropdown -->
  <div class="dropdown">
    <!-- <label class="fw-bold me-2"></label> -->
    <button class="btn btn-outline-primary dropdown-toggle shadow-sm" data-bs-toggle="dropdown">
      Breakpoints: <i class="fa-solid fa-layer-group"></i>
    </button>
    <div class="dropdown-menu p-3 shadow-lg rounded-3" style="min-width: 220px;">
      <div class="form-check mb-2">
          <input class="form-check-input" type="checkbox" id="regionCheck" [(ngModel)]="breakpoints.region">
          <label class="form-check-label" for="regionCheck">Region</label>
      </div>
      <div class="form-check mb-2">
          <input class="form-check-input" type="checkbox" id="tagNameCheck1" [(ngModel)]="breakpoints.product_family">
          <label class="form-check-label" for="tagNameCheck1">Product Family</label>
      </div>
      <div class="form-check mb-3" *ngIf="selectedView == 'monthly'">
          <input class="form-check-input" type="checkbox" id="tagNameCheck2" [(ngModel)]="breakpoints.line_item">
          <label class="form-check-label" for="tagNameCheck2">Line Item</label>
      </div>
      <div class="d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-secondary" (click)="clearPreferences()">Clear</button>
      <button type="button" class="btn btn-primary" (click)="onSubmitClick()">Submit</button>
      </div>
    </div>
  </div>

  <!-- Items per page -->
  <div class="d-flex align-items-center">
    <label class="fw-bold me-2">Items per page:</label>
    <input type="number"
           class="form-control form-control-sm shadow-sm border-primary"
           style="width: 90px;"
           name="pageSize"
           min="20" max="100" step="20" value="20"
           [(ngModel)]="selectedPageSize"
           (change)="onPageSizeChangeFromModal()" />
  </div>

</div>
